
import React, { Fragment } from 'react';
import PageTitle from '../../components/pagetitle/PageTitle';
import LoginHeaderR from '../../components/header/LoginHeaderR';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/FooterW';
import Policy from '../../components/PrivacyPolicy/privacypolicy';

const PrivacyPolicyR = (props) => {

    return (
        <Fragment>
            <div className='index_ico page_wrapper'>
                <LoginHeaderR />
                <main className="page_content">
                    <PageTitle pageTitle={'Privacy Policy'} pagesub={'Home'} />
                    <Policy abClass={'pt-0'}/>
                </main>
                <Footer />
                <Scrollbar />
            </div>
        </Fragment>
    )
};
export default PrivacyPolicyR;